var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontIconImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4895_50590)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4419,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.53516H23.4419",
    stroke: "black",
    strokeWidth: 0.27907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4648H23.4419",
    stroke: "black",
    strokeWidth: 0.27907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.466895 16.1406L7.57982 4.53272H9.30866L12.7005 16.1406H10.6753L9.85201 13.0123L10.5106 13.4568H3.69406L4.51731 13.0616L2.70615 16.1406H0.466895ZM8.17257 6.82137L5.0442 12.1561L4.68196 11.7774H10.0661L9.6215 12.189L8.2055 6.82137H8.17257ZM16.5227 16.3053C16.0287 16.3053 15.5787 16.1955 15.1726 15.976C14.7664 15.7455 14.4371 15.4436 14.1847 15.0704C13.9432 14.6972 13.8224 14.2801 13.8224 13.819C13.8224 13.2483 13.9816 12.7872 14.2999 12.436C14.6182 12.0737 15.1122 11.8048 15.7818 11.6292C16.4513 11.4536 17.3075 11.3657 18.3503 11.3657H19.6675L19.4864 12.5512H18.4491C17.8015 12.5512 17.2856 12.5842 16.9014 12.65C16.5172 12.7159 16.2428 12.8311 16.0781 12.9958C15.9135 13.1604 15.8312 13.391 15.8312 13.6873C15.8312 14.0715 15.9574 14.3679 16.2099 14.5764C16.4733 14.785 16.7916 14.8893 17.1648 14.8893C17.5161 14.8893 17.8344 14.8179 18.1198 14.6752C18.4052 14.5216 18.6467 14.3075 18.8443 14.0331C19.0419 13.7477 19.1681 13.4129 19.223 13.0287L19.5358 11.0694C19.6236 10.5535 19.5413 10.1583 19.2888 9.88388C19.0473 9.60946 18.6193 9.47225 18.0046 9.47225C17.5216 9.47225 17.0496 9.53811 16.5886 9.66983C16.1385 9.80156 15.6885 10.0101 15.2384 10.2955L14.7774 8.87951C15.0518 8.68193 15.3756 8.51179 15.7488 8.36909C16.133 8.22639 16.5392 8.11663 16.9673 8.03979C17.4063 7.96295 17.8399 7.92453 18.268 7.92453C19.1352 7.92453 19.8157 8.0837 20.3097 8.40202C20.8036 8.72035 21.1384 9.15393 21.314 9.70276C21.4897 10.2516 21.5226 10.8773 21.4128 11.5798L20.6884 16.1406H18.762L19.0254 14.4283H19.19C19.0364 14.8563 18.8168 15.2131 18.5314 15.4985C18.257 15.7729 17.9442 15.976 17.5929 16.1077C17.2527 16.2394 16.8959 16.3053 16.5227 16.3053Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.139535,
    y: 0.139535,
    width: 23.1628,
    height: 23.7209,
    rx: 2.09302,
    stroke: "#DDDFDD",
    strokeWidth: 0.27907
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4895_50590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4419,
    height: 24,
    rx: 2.23256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontIconImg);
export default __webpack_public_path__ + "static/media/FontIcon-img.415c455e6a3c2cf7edb192f15a7e6699.svg";
export { ForwardRef as ReactComponent };